// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"35dde8fd","787":"5ea043b5"}[chunkId] + ".chunk.js";
};